import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { Picture } from "../lib/photos";

export function Lightbox({ photos, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (index === -1) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [index, onClose, onNext, onPrev]);

  if (index === -1) return null;
  const photo = photos[index];
  if (!photo) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-forest-900/95 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
      role="dialog"
      aria-modal="true"
      aria-label={photo.alt}
      data-testid="lightbox"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 md:top-6 md:right-6 text-cream hover:text-brass transition-colors"
        aria-label="Close lightbox"
        data-testid="lightbox-close"
      >
        <X size={28} />
      </button>
      <button
        onClick={onPrev}
        className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 text-cream hover:text-brass p-2"
        aria-label="Previous photo"
        data-testid="lightbox-prev"
      >
        <ChevronLeft size={40} />
      </button>
      <button
        onClick={onNext}
        className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 text-cream hover:text-brass p-2"
        aria-label="Next photo"
        data-testid="lightbox-next"
      >
        <ChevronRight size={40} />
      </button>
      <figure className="max-w-6xl max-h-[85vh] flex flex-col items-center gap-4">
        <Picture
          photo={photo}
          className="block max-h-[75vh]"
          imgClassName="max-h-[75vh] w-auto rounded-sm shadow-lift"
          sizes="90vw"
          loading="eager"
        />
        <figcaption className="text-cream/85 text-sm md:text-base max-w-2xl text-center">
          {photo.caption || photo.alt}
        </figcaption>
      </figure>
    </div>
  );
}
